import { Badge, IconButton, Popover, Tooltip } from "@aurem/ui";
import { BellIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useEffect, useRef } from "react";
import { useFeature } from "../../providers/FeaturesProvider";
import { NotificationDropdown } from "./components/NotificationDropdown";
import { NotificationProvider, useNotificationContext } from "./context";

const NotificationPopover = () => {
  const { t } = useI18n();
  const { unreadCount, refetch, isOpen, setIsOpen } = useNotificationContext();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (isOpen && !hasInitialized.current) {
      hasInitialized.current = true;
      refetch();
    }
  }, [isOpen, refetch]);

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-end"
      offset={8}
      maxWidth={440}
      contentClassName="p-0 w-full"
      content={<NotificationDropdown />}
    >
      <Tooltip content={t("apps.admin.notifications.title")} placement="bottom">
        <IconButton
          aria-label={t("apps.admin.notifications.title")}
          variant="ghost"
          color="neutral"
        >
          <Badge
            content={unreadCount}
            color="danger"
            hide={unreadCount === 0}
            offset={-21}
            className="flex items-center justify-center"
          >
            <BellIcon size="1.325rem" />
          </Badge>
        </IconButton>
      </Tooltip>
    </Popover>
  );
};

export const NotificationCenter = () => {
  const isTasksEnabled = useFeature("tasks_feature");

  if (!isTasksEnabled) {
    return null;
  }

  return (
    <NotificationProvider>
      <NotificationPopover />
    </NotificationProvider>
  );
};

export type { Notification, NotificationData } from "./types";
